import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function CalendarPage() {
    const [items, setItems] = useState([]);
    const [courses, setCourses] = useState([]);
    const [month, setMonth] = useState(new Date());

    useEffect(() => {
        (async () => {
            const [a, c] = await Promise.all([api.get("/assignments"), api.get("/courses")]);
            setItems(a.data); setCourses(c.data);
        })();
    }, []);

    const year = month.getFullYear();
    const m = month.getMonth();
    const first = new Date(year, m, 1);
    const startDay = first.getDay();
    const daysInMonth = new Date(year, m + 1, 0).getDate();
    const cells = [];
    for (let i = 0; i < startDay; i++) cells.push(null);
    for (let d = 1; d <= daysInMonth; d++) cells.push(new Date(year, m, d));

    const courseColor = (id) => courses.find(c => c.id === id)?.color || "hsl(var(--primary))";
    const today = new Date(); today.setHours(0, 0, 0, 0);

    const dueOn = (day) => items.filter(a => a.due_date && new Date(a.due_date).toDateString() === day.toDateString());

    return (
        <div className="space-y-8" data-testid="calendar-page">
            <header className="flex items-end justify-between">
                <div>
                    <div className="mono-label">Calendar</div>
                    <h1 className="font-display text-4xl font-medium tracking-tight mt-2">
                        {month.toLocaleDateString(undefined, { month: "long", year: "numeric" })}
                    </h1>
                </div>
                <div className="flex gap-2">
                    <button className="px-3 py-1.5 rounded-lg border border-border hover:bg-muted text-sm" onClick={() => setMonth(new Date(year, m - 1, 1))} data-testid="prev-month">←</button>
                    <button className="px-3 py-1.5 rounded-lg border border-border hover:bg-muted text-sm" onClick={() => setMonth(new Date())}>Today</button>
                    <button className="px-3 py-1.5 rounded-lg border border-border hover:bg-muted text-sm" onClick={() => setMonth(new Date(year, m + 1, 1))} data-testid="next-month">→</button>
                </div>
            </header>

            <div className="bg-card rounded-2xl border border-border/60 p-4">
                <div className="grid grid-cols-7 gap-2 mb-2">
                    {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map(d => (
                        <div key={d} className="mono-label text-center py-2">{d}</div>
                    ))}
                </div>
                <div className="grid grid-cols-7 gap-2">
                    {cells.map((day, i) => {
                        const cellKey = day ? `d-${day.toISOString()}` : `blank-${i}`;
                        if (!day) return <div key={cellKey} className="min-h-[110px]" />;
                        const isToday = day.getTime() === today.getTime();
                        const due = dueOn(day);
                        return (
                            <div key={cellKey} className={`min-h-[110px] rounded-xl border p-2 transition ${isToday ? "border-primary bg-primary/5" : "border-border/50 bg-background"}`}>
                                <div className={`text-xs font-mono mb-1 ${isToday ? "text-primary font-bold" : "text-muted-foreground"}`}>{day.getDate()}</div>
                                <div className="space-y-1">
                                    {due.slice(0, 3).map(a => (
                                        <div key={a.id} className="text-[11px] px-1.5 py-0.5 rounded truncate" style={{ background: courseColor(a.course_id) + "20", color: courseColor(a.course_id) }} title={a.title}>{a.title}</div>
                                    ))}
                                    {due.length > 3 && <div className="text-[10px] text-muted-foreground">+{due.length - 3} more</div>}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
